import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import {useAnalytics} from '../AnalyticsContext'
import { logEvent } from "firebase/analytics";

function Token({ toRedirect, callBack, showReenviar, onchangeCode }) {

    const analytics = useAnalytics();
    const [token, setToken] = useState('');
    const navigate = useNavigate();

    const handleChange = (index, value) => {
        if (value.length > 1) {
            const numbersOnly = value.replace(/\D/g, '').substring(0, 6);
            if (numbersOnly) {
                const newToken = (token.substring(0, index) + numbersOnly).substring(0, 6);
                setToken(newToken);
                if (onchangeCode) onchangeCode();
                const nextIndex = Math.min(index + numbersOnly.length, 5);
                const nextInput = document.getElementById(`input-${nextIndex}`);
                if (nextInput) nextInput.focus();
            }
            return;
        }

        const numValue = parseInt(value, 10);
        if (!isNaN(numValue)) {
            const newToken = (token.substring(0, index) + numValue + token.substring(index + 1)).substring(0, 6);
            setToken(newToken);
            if (index < 5) {
                const nextInput = document.getElementById(`input-${index + 1}`);
                if (nextInput) nextInput.focus();
            }
        }
    };

    const handlePaste = (index, e) => {
        e.preventDefault();
        const paste = e.clipboardData.getData('text');
        const numbersOnly = paste.replace(/\D/g, '').substring(0, 6);
        if (numbersOnly) {
            const newToken = (token.substring(0, index) + numbersOnly).substring(0, 6);
            setToken(newToken);
            if (onchangeCode) onchangeCode();
            const nextIndex = Math.min(index + numbersOnly.length, 5);
            const nextInput = document.getElementById(`input-${nextIndex}`);
            if (nextInput) nextInput.focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace') {
            e.preventDefault();
            const newToken = token.substring(0, index) + token.substring(index + 1);
            setToken(newToken);

            if (index > 0) {
                const prevInput = document.getElementById(`input-${index - 1}`);
                if (prevInput) prevInput.focus();
            }
        }

        if(onchangeCode){
            onchangeCode();
        }
    };

    const enviarToken = (e) => {
        e.preventDefault();
 
        logEvent(analytics, "Login_verificar_codigo", {
            screen_name: "Login",
        });


        if (toRedirect && toRedirect !== "") {
            navigate(toRedirect)
        } else if (callBack) {
            callBack(token)
        }


    }

    return (
        <form onSubmit={enviarToken}>
            {Array.from({ length: 6 }, (_, index) => (
                <div className='col s2' key={index}>
                    <input
                        key={index}
                        id={`input-${index}`}
                        type="text"
                        className='inputToken'
                        maxLength="1"
                        value={token[index] || ''}
                        onChange={(e) => handleChange(index, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        onPaste={(e) => handlePaste(index, e)}
                        style={{ width: '30px', marginRight: '5px', textAlign: 'center' }}
                        tabIndex={index + 1}
                        autoFocus={index === 0}
                    />
                </div>
            ))}
            <div className='col s12 mt-1'>
                <button type="submit"
                    disabled={token.length < 6}
                    className="btn btn-webSi-primary waves-effect light">Confirmar</button>
            </div>
            {
                showReenviar ?
                    <div className='col s12 mt-2'>
                        <label className='cursorPointer ft-16'>Reenviar Código</label>
                    </div>
                    : null
            }

        </form>
    );

}

export default Token;